// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@conklin/XDL/types";
import { css } from "styled-components";

export const fontConfig = {
    url: "https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,400;0,700;0,900;1,400&display=swap",
    weight: {
        regular: 400,
        bold: 700,
        black: 900,
    },
    fontSize: {
        small: 12,
    },
    lineHeight: {
        small: "15px",
    },
    fontFamily: " 'Lato', sans-serif",
};

export default {
    fontFamilyImportUrl: fontConfig.url,
    body: {
        size: "16px",
        weight: fontConfig.weight.regular,
        color: "text.main",
        lineHeight: "26px",
        fontFamily: fontConfig.fontFamily,
    },
    p: {
        size: "16px",
        weight: fontConfig.weight.regular,
        lineHeight: "26px",
        css: css`
            margin-bottom: 16px;
            letter-spacing: 0;
            line-height: 26px;
            display: block;
        `,
    },
    h1: {
        size: "28px",
        weight: fontConfig.weight.black,
        lineHeight: "34px",
        css: css`
            margin-bottom: 16px;
            letter-spacing: 0;
            line-height: 34px;
            display: block;
        `,
    },
    h2: {
        size: "24px",
        weight: fontConfig.weight.black,
        lineHeight: "29px",
        css: css`
            margin-bottom: 16px;
            letter-spacing: 0;
            line-height: 29px;
            display: block;
        `,
    },
    h3: {
        size: "20px",
        weight: fontConfig.weight.black,
        lineHeight: "24px",
        css: css`
            margin-bottom: 12px;
            letter-spacing: 0;
            line-height: 24px;
            display: block;
        `,
    },
    h4: {
        size: "18px",
        weight: fontConfig.weight.black,
        lineHeight: "22px",
        css: css`
            margin-bottom: 12px;
            letter-spacing: 0;
            line-height: 22px;
            display: block;
        `,
    },
    h5: {
        size: "16px",
        weight: fontConfig.weight.bold,
        lineHeight: "19px",
        css: css`
            margin-bottom: 12px;
            letter-spacing: 0;
            line-height: 19px;
            display: block;
        `,
    },
    h6: {
        size: "14px",
        weight: fontConfig.weight.bold,
        lineHeight: "17px",
        css: css`
            margin-bottom: 12px;
            letter-spacing: 0;
            line-height: 17px;
            display: block;
        `,
    },
    headerPrimary: {
        forwardAs: "p",
        size: "24px",
        fontFamily: fontConfig.fontFamily,
        color: "text.main",
        transform: "uppercase",
    },
    headerSecondary: {
        forwardAs: "p",
        size: "18px",
        fontFamily: fontConfig.fontFamily,
        weight: fontConfig.weight.black,
        lineHeight: "22px",
        transform: "capitalize",
        css: css`
            line-height: 22px;
            font-weight: ${fontConfig.weight.black};
        `,
    },
    headerTertiary: {
        forwardAs: "p",
        size: "15px",
        fontFamily: fontConfig.fontFamily,
        color: "text.main",
        transform: "uppercase",
    },
    legend: {
        forwardAs: "span",
        size: "10px",
        color: "text.accent",
        transform: "uppercase",
        weight: 600,
    },
} as xBaseTheme["typography"];
